import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { TabView, TabPanel } from 'primereact/tabview';
import PayrollHistory from "./PayrollHistory";
import Loader from "../../Layout/Loader";
import PayrollInfo from "./PayrollInfo";
import PayrollComments from "./PayrollComments";
import PayrollBankAccounts from "./PayrollBankAccounts";
import { globalHandleChange } from "../../../services/functions";
import SummaryPayrollTable from "./PayrollSummary";
import PayrollTotals from "./PayrollTotals";
import PayrollData from "./PayrollData";
import { defaultPayroll, isPayrollValid } from "./PayrollUtils";
import { useSavePayroll } from "./service";
import "../open-banking.scss"
import "./payroll.scss";

const CreatePayroll = (props) => {
  const { t } = useTranslation("translations");
  const [payrollAttachments, setPayrollAttachments] = useState([]);
  const [validationErrors,setValidationErrors] = useState({})

  const [payroll, setPayroll] = useState(defaultPayroll);
  const valid = ({validateOnlyEmployeesFields=false,excludeFields,updatedPayroll}={})=>isPayrollValid({validateOnlyEmployeesFields,t,setValidationErrors,payroll:updatedPayroll ?? payroll,excludeFields})
  const {savePayrollFn,loading:savingPayroll} = useSavePayroll({valid})

  const handleChange = (e, selectKey, selectValue, length) => {
    const key = e?.target?.name ?? selectKey
    const value = (e?.target?.value ?? selectValue)
    if(validationErrors[key]){
      setValidationErrors(validationErrors=>({...validationErrors,[key]:null}))
    }
    globalHandleChange({ key, value, setState: setPayroll, length });
  }


  const savePayroll=()=>{
    const attachments = payrollAttachments.map(({source,...restAtt})=>({...restAtt}))
    savePayrollFn({payroll:{...payroll,attachments}})
    setPayrollAttachments([])
  }

  const staticButtons = (
    <>
      <button
        className={`btn btn-sm btn-primary mr-3`}
        disabled={savingPayroll}
        style={{ minWidth: "100px" }}
        onClick={() => savePayroll()}
      >
        {savingPayroll ? <Loader size="xs" color="white" /> : t("common.save")}
      </button>
    </>
  );



  const disabled = false;

  return (
    <div className="row payroll-page mt-1 open-banking">
      <div className="col-12 pt-0">
        <div className="card p-xl-2">
          <div className="d-flex align-items-center justify-content-between mb-1 mt-1 gap-y-2">
            <div className="d-flex align-items-center justify-content-center">
              <h3 className="mb-0 mr-4">{t("payRoll.createPayroll")}</h3>
            </div>
            <div className="d-flex align-items-center">
              {staticButtons}
            </div>
          </div>

          <div className="my-2 border-top border-success"></div>
          <div className="row">
            <div className="col-12 col-md-5 border-right" style={{height:"100% !important"}}>
              <PayrollInfo 
                payroll={payroll} 
                setPayroll={setPayroll}
                handleChange={handleChange}
                disabled={disabled}
                validationErrors={validationErrors}
              />
            </div>
            <div className="col-12 col-md-3 border-right" style={{height:"100% !important"}}>
              <PayrollBankAccounts 
                payroll={payroll}
                setPayroll={setPayroll}
                handleChange={handleChange} 
                disabled={disabled}
                validationErrors={validationErrors}
                />
            </div>
            <div className="col-12 col-md-4" style={{height:"100% !important"}}>
                <PayrollData
                  payroll={payroll} 
                  setPayroll={setPayroll}
                  handleChange={handleChange}
                  disabled={disabled}
                  validationErrors={validationErrors}

                />
            </div>
          </div>
          <div className="row">
            <div className="col-12 py-0" style={{minHeight:120,maxHeight:400}}>
              <SummaryPayrollTable 
                payroll={payroll}
                setPayroll={setPayroll}
                valid={valid}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>
          </div>
          <div className="row align-items-start" style={{minHeight:250}}>
            <div className="col-12 col-md-6 border-left" >
              <TabView>
                <TabPanel header={t("openBanking.attachmentsComments")}>
                  <PayrollComments
                    payroll={payroll}
                    setPayroll={setPayroll}
                    handleChange={handleChange}
                    payrollAttachments={payrollAttachments}
                    setPayrollAttachments={setPayrollAttachments}
                    disabled={disabled}
                  />
                </TabPanel>
                <TabPanel header={t("payRoll.payrollHistory")}>
                  <PayrollHistory payroll={payroll} disabled={disabled} />
                </TabPanel>
                {/* <TabPanel header={t("invoice.documentPreview")}>
                  <PayrollDocPreview
                    payrollAttachments={payrollAttachments}
                    setPayrollAttachments={setPayrollAttachments}
                    payrollId={payrollId}
                    disabled={disabled}
                  />
                </TabPanel> */}
              </TabView>
            </div>
            <div className="col-12 col-md-6 border-t">
              <PayrollTotals payroll={payroll} setPayroll={setPayroll}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatePayroll;